import { useState } from "react";
import { Typography, Stack, Divider } from "@financeable-com-au/financeable-ui";
import { ApplicationType } from "@/store/slices/types/applicationFormSlice";
import { getIsConsumerOrPersonalApplication, SIGNATURE_TYPE } from "@/constants";
import { useFeatureFlags } from "@/utils/featureFlags";
import { CreditGuide } from "./CreditGuide";
import { PrivacyStatementLegacy } from "./PrivacyStatement/PrivacyStatementLegacy";
import { Signature } from "../Signature";
import ServiceAgreement from "../Signature/ServiceAgreement";

export interface PrivacyParams {
  cid: string;
  aid: string;
  uid: string;
  templateType: string;
  jwt: string;
}

interface PrivacyCreditGuideProps {
  applicationType: ApplicationType;
  params: PrivacyParams;
}

const PrivacyCreditGuide = ({ applicationType, params }: PrivacyCreditGuideProps) => {
  const { documentTemplateUplift } = useFeatureFlags();
  const showConsumerPrivacyCreditGuide = getIsConsumerOrPersonalApplication(applicationType);
  const [submitted, setSubmitted] = useState(false);

  if (submitted) {
    return (
      <Stack flexDirection="column" rowGap={5} paddingBottom={10}>
        <Stack flexDirection="column" rowGap={2}>
          <Typography level="title-lg">Agreement Signed Successfully</Typography>
          <Typography level="body-lg">
            Too easy! You're one step closer and not far to go now. Enjoy the rest of your day.
          </Typography>
        </Stack>
        <Divider />
        <Typography level="body-md">You can close this window.</Typography>
      </Stack>
    );
  }
  return (
    <Stack flexDirection="column" rowGap={5} paddingBottom={10}>
      <Stack flexDirection="column" rowGap={2}>
        <Typography level="title-lg">
          Privacy Disclosure Statement {showConsumerPrivacyCreditGuide && "& Credit Guide"}
        </Typography>
        <Typography level="body-lg">
          Please read the privacy statement {showConsumerPrivacyCreditGuide && "and credit guide"} then sign at the
          bottom.
        </Typography>
      </Stack>
      <Divider />
      {documentTemplateUplift() ? (
        <ServiceAgreement params={params} serviceAgreementType={SIGNATURE_TYPE.PRIVACY} />
      ) : (
        <>
          <PrivacyStatementLegacy applicationType={applicationType} />
          {showConsumerPrivacyCreditGuide && <CreditGuide />}
        </>
      )}

      <Signature signatureType={SIGNATURE_TYPE.PRIVACY} setSubmitted={setSubmitted} />
    </Stack>
  );
};

export { PrivacyCreditGuide };
